import React, { Component } from "react";

import environmentalBook from "./images/environmental-book.JPG";
import distributiveBook from "./images/distributive-book.png";

class Books extends Component {
  constructor(props) {
    super(props);
    this.bookRef = React.createRef();
  }

  state = {
    first_par:
      "No skills, no cooperation. That is the core finding of this book, which seeks to explain international inter-agency cooperation in the Global South. Policymaking has become more complex in the information age, more international and interdependent in a globalized world, and more pressed by the urgency of the problems it attempts to address. Much of international cooperation is unthinkable without a large body of expert bureaucrats greasing and turning the wheels of the government machine. In other words, policymaking has become both more skill dependent and transnational. Yet, while high-level diplomacy and multilateral treaties receive the bulk of scholarly attention, the “behind-the-scene” legwork that expert bureaucrats do on a regular basis has not been properly studied.",
    second_par:
      "Partnerships among bureaucrats can yield extraordinary outcomes. The Kyoto Protocol would not have been possible without the preceding coordinated efforts of state climatologists around the world; the Non Pro-liferation Treaty (NPT) and the Comprehensive Test Ban Treaty (CTBT) would not have been realized if it had not been for the prior work by nuclear bureaucrats from both nuclear and non-nuclear powers; and world summits on wide-ranging issues, like sustainable development...",
  };

  render() {
    return (
      <div style={bookStyle} ref={this.bookRef}>
        <h2 style={bookTitle}>Books</h2>
        <div style={bookWrapper}>
          <div style={bookImageContainerStyle}>
            <a
              href="https://www.cambridge.org/core/books/environmental-and-nuclear-networks-in-the-global-south/868C8B93E787E55560E14303032040C8"
              target="_blank"
            >
              <img src={environmentalBook} alt="Book" style={bookImageStyle} />
            </a>
          </div>
          <div style={bookImageContainerStyle}>
            <a
              href="https://www.cambridge.org/core/elements/distributive-politics-of-environmental-protection-in-latin-america-and-the-caribbean/9AAD1CFDC6071967FC77EAC2F644EB3E"
              target="_blank"
            >
              <img src={distributiveBook} alt="Book" style={bookImageStyle} />
            </a>
          </div>
        </div>
      </div>
    );
  }
}

const bookStyle = {
  maxWidth: "1300px",
  margin: "auto",
  position: "relative",
  padding: "30px 100px 60px 100px",
};

const bookWrapper = {
  display: "flex",
  flexWrap: "wrap",
  gap: "2rem",

  marginTop: "1rem",
  background: "#fff",
  width: "100%",
};

const bookTitle = {
  fontFamily: "Lora, serif",
  fontSize: "40px",
};

const bookImageContainerStyle = {};

const bookImageStyle = {
  height: "400px",
};

const moreStyle = {
  fontSize: "20px",
};

export default Books;
